export default [
    {
        path: '/*',
        component: () => import('./404.vue'),
        //children:[],
        //redirect: '',
    }
]